import React, {useContext} from 'react';
import styled from 'styled-components';
import MobileNav from '../MobileNav/MobileNav';
import {useMediaQuery} from '../../hooks/useMediaQuery';
import Navbar from '../Navbar/Navbar';
import {CurrentState} from '../../context';


const Layout = ({children}) => {

  const isMobile = useMediaQuery(768);
  const currentState = useContext(CurrentState);
  const {isAdmin} = currentState

  let navItemsList = [
    {title:'SEARCH', link:'/', exact:true}
  ]
  // if (currentCompany) {
  //   navItemsList = navItemsList.concat( [
  //     {title:'DISPLAY', link:`/display/${currentCompany.companyId}?companyName=${currentCompany.companyName}`},
  //   ])
  // }
  navItemsList = navItemsList.concat( [
    {title:'MESSAGES', link:`/recent-messages`},
  ])
  if (isAdmin) {
    navItemsList = navItemsList.concat([
      {title:'INTERESTS', link:'/interests'},
      {title:'ADMIN', link:'/admin'},
    ])
  }

  return (
    <div>
      {isMobile ? <MobileNav navItems={navItemsList} /> : (
          <Navbar navItems={navItemsList}/>
      )}
      <Main isMobile={isMobile}>{children}</Main>
    </div>
  );
};

const Main = styled.div`

  margin-top: 75px;
  margin-left: 10px;
`;

export default Layout;
